<template>
  <div>
    <tci-service-head :title="$t('service.service3.title')" :subtitle="$t('service.service3.subtitle')" :content="$t('service.service3.content')" :imgUrl='$i18n.locale=="zh"?require("../assets/service/s3-1.jpg"):require("../assets/service/s3-1-ja.jpg")'>
    </tci-service-head> 
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
import TciServiceHead from "@/components/TciServiceHead.vue";

export default {
  name: "CompanyService3",
  components: {
    "tci-contact-footer": TciContactFooter,
    "tci-service-head": TciServiceHead
  }
};
</script>
